export default __webpack_public_path__ + "static/media/laundry2-before-1440w.5265e82f.png";